import { useEffect, useState } from 'react';

/**
 * true onder de gegeven breakpoint (standaard 768px, Tailwind's `md`) --
 * matchMedia-gebaseerd i.p.v. eenmalige innerWidth-check, zodat
 * device-rotatie en browservenster-resize meteen worden opgepikt. Zelfde
 * defensieve patroon als usePrefersReducedMotion.ts (jsdom kent geen
 * matchMedia, dus test-omgevingen vallen terug op false = desktop-layout).
 */
export default function useIsMobile(breakpointPx = 768): boolean {
  const query = `(max-width: ${breakpointPx - 1}px)`;
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mediaQuery = window.matchMedia(query);
    const handleChange = () => setIsMobile(mediaQuery.matches);
    handleChange();
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [query]);

  return isMobile;
}
